import { login, logout, getInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  account_id: null,
  name: '',
  surname: '',
  email: '',
  site_id: null,
  lab_id: null,
  role: '',
  rules: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_ACCOUNT_ID: (state, accountId) => {
    state.account_id = accountId
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_SURNAME: (state, surname) => {
    state.surname = surname
  },
  SET_EMAIL: (state, email) => {
    state.email = email
  },
  SET_ROLE: (state, role) => {
    state.role = role
  },
  SET_RULES: (state, rules) => {
    state.rules = rules
  },
  SET_SITE_ID: (state, site_id) => {
    state.site_id = site_id
  },
  SET_LAB_ID: (state, lab_id) => {
    state.lab_id = lab_id
  }
}

const actions = {
  // user login
  login ({ commit }, userInfo) {
    const { username, password } = userInfo

    return new Promise((resolve, reject) => {
      login({ username, password }).then(
        response => {
          if (response.account.role === 'Provider') {
            reject(Error('Provider role is not allowed to frontend!'))
            return
          }
          commit('SET_TOKEN', response.token)
          commit('SET_ACCOUNT_ID', response.account_id)
          commit('SET_ROLE', response.account.role)
          commit('SET_SITE_ID', response.account.site_id)
          commit('SET_LAB_ID', response.account.lab_id)
          setToken(response.token)
          resolve(response)
        }
      ).catch(error => {
        reject(Error(error.response.data.message))
      })
    })
  },

  // set token manually
  setToken ({commit}, token) {
    commit('SET_TOKEN', token)
    setToken(token)
    return new Promise((resolve, reject) => {
      getInfo().then(data => {
        if (!data) {
          reject(Error('Verification failed, please Login again.'))
        }

        commit('SET_NAME', data.account.name)
        commit('SET_SURNAME', data.account.surname)
        commit('SET_EMAIL', data.account.email)
        commit('SET_ROLE', data.account.role)
        commit('SET_SITE_ID', data.account.site_id)
        commit('SET_LAB_ID', data.account.lab_id)
        commit('SET_RULES', data.rules)

        resolve(data)
      }).catch(error => {
        reject('REJECT ' + error)
      })
    })    
  },
  // get user info
  getInfo (context) {
    return new Promise((resolve, reject) => {
      getInfo().then(data => {
        if (!data) {
          reject(Error('Verification failed, please Login again.'))
        }

        context.commit('SET_ACCOUNT_ID', data.account_id)
        context.commit('SET_NAME', data.account.name)
        context.commit('SET_SURNAME', data.account.surname)
        context.commit('SET_EMAIL', data.account.email)
        context.commit('SET_ROLE', data.account.role)
        context.commit('SET_SITE_ID', data.account.site_id)
        context.commit('SET_LAB_ID', data.account.lab_id)
        context.commit('SET_RULES', data.rules)

        const today = new Date();
        const passExpireDate = new Date(data.account.password_expire)

        if( today > passExpireDate && data.account.role!=='EMN Client') {
          context.dispatch("app/openChangePassword", {title:'Your password is expired! Please change it.', force:true}, {root:true})
        }

        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout ({ commit, state }) {
    return new Promise((resolve) => {
      logout(state.token).finally(() => {
        commit('SET_TOKEN', '')
        commit('SET_NAME', '')
        commit('SET_SURNAME', '')
        commit('SET_EMAIL', '')
        commit('SET_ROLE', '')
        commit('SET_SITE_ID', '')
        commit('SET_LAB_ID', '')
        removeToken()
        resolve()
      })
      // resetRouter()
    })
  },

  // remove token
  resetToken ({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_NAME', '')
      commit('SET_SURNAME', '')
      commit('SET_EMAIL', '')
      commit('SET_ROLE', '')
      commit('SET_SITE_ID', '')
      commit('SET_LAB_ID', '')
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
